import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { FacilityReportRouteSearchData } from "../../../../models/FacilityReportData";
import LineChart from "../../../AnalysisCollectionsComponents/CollectionChartArea/LineChart";
import { EditableAISummary } from "../EditableAISummary";

interface IRouteSearchSectionProps {
  routeSearch?: FacilityReportRouteSearchData;
  isDownloading: boolean;
  facilityReportId: string;
}

export const RouteSearchSection: React.FunctionComponent<
  IRouteSearchSectionProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityReportsPage.facilityReportDetails.${key}`);
  const { routeSearch, isDownloading, facilityReportId } = props;

  const [timeUnit, setTimeUnit] = useState<"day" | "week" | "month">(
    routeSearch?.time_unit ?? "day"
  );

  if (!routeSearch) {
    return null;
  }

  return (
    <div className="route-search-section white-border-panel facility-report-details-section">
      <div
        className="inner-container"
        id="facility-report-details-route-search-section"
      >
        <EditableAISummary
          title={t("routeSearchSection.title")}
          summary={routeSearch.ai_summary}
          facilityReportId={facilityReportId}
          patchKey="route_search"
          isDownloading={isDownloading}
        />
        {!routeSearch.route_search_data ? (
          <p className="no-data-message">{t("no_data")}</p>
        ) : (
          <LineChart
            chartDetailsData={routeSearch.route_search_data}
            usePrevYear={false}
            timeUnit={timeUnit}
            skipLabelTranslation={false}
            setTimeUnit={setTimeUnit}
            showTimeUnitSelect={!isDownloading}
            chartContainerId="facility-report-details-route-search-chart"
          />
        )}
      </div>
    </div>
  );
};
